var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddNewCompany(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4C7.6 4 4 7.6 4 12C4 16.4 7.6 20 12 20C16.4 20 20 16.4 20 12C20 7.6 16.4 4 12 4ZM12 5.14286C15.7714 5.14286 18.8571 8.22857 18.8571 12C18.8571 15.7714 15.7714 18.8571 12 18.8571C8.22857 18.8571 5.14286 15.7714 5.14286 12C5.14286 8.22857 8.22857 5.14286 12 5.14286Z",
    fill: "#07A0C3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5716 11.4287H12.5716V7.42871H11.4287V11.4287H7.42871V12.5716H11.4287V16.5716H12.5716V12.5716H16.5716V11.4287Z",
    fill: "#07A0C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddNewCompany);
export default __webpack_public_path__ + "static/media/add-new-company.f294e5f8940189ffc1630864e841cfae.svg";
export { ForwardRef as ReactComponent };